module.exports = __webpack_public_path__ + "img/22_63.91e06ecc.png";